import { IIssueMachineHealthResponse } from '@kcftech/prometheustypescriptapiclient';
import { GroupHierarchyText } from 'components/group_hierarchy/GroupHierarchyText';
import { IssueGroupUnboundMessage } from 'pages/Desk/issues/issue_details/header/IssueName';
import { memo } from 'react';
import { takeLast } from 'utils/array';

export function IssueFaultLocationPathBase({
    issue,
}: {
    issue: IIssueMachineHealthResponse;
}) {
    return issue.Group ? (
        <GroupHierarchyText
            hierarchy={takeLast(issue.Hierarchy, issue.Hierarchy.length - 1, 1)}
            useFullGroupName
            showHierarchySuffix
            wrapHierarchyString
            // Manually specify className to avoid default `text-nowrap`
            suffixClassName="bold"
            suffix={`${issue.Group.GroupName}${
                issue.Group.GroupSuffix ? ` (${issue.Group.GroupSuffix})` : ''
            }`}
        />
    ) : (
        <IssueGroupUnboundMessage />
    );
}

export const IssueFaultLocationPath = memo(IssueFaultLocationPathBase);
